
import { defineComponent } from "vue";

export default defineComponent({
  name: "headerChild",
  props: {
    title: {
      type: String,
      required: true
    },
    numbersOfItems: {
      type: Number,
      required: false
    },
    svgdata: {
      type: String,
      require: true
    },
    hasAddButton: {
      type: Boolean,
      require: true,
      default: true
    },
    isValid: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    addItem() {
      this.$emit("addItem");
    }
  }
});
